"use strict";
/**
 * Attendance Correction Enums
 *
 * Issues found when evaluating an attendance correction request. `errors` block the
 * request (create and approve); `warnings` let it through but are shown to the
 * collaborator before sending and to the reviewer before approving.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTENDANCE_CORRECTION_GRACE_DAYS = exports.ATTENDANCE_UNUSUAL_END_AFTER = exports.ATTENDANCE_UNUSUAL_START_BEFORE = exports.ATTENDANCE_CORRECTION_ISSUE_LABELS = exports.AttendanceCorrectionIssueCode = void 0;
var AttendanceCorrectionIssueCode;
(function (AttendanceCorrectionIssueCode) {
    // Errors
    AttendanceCorrectionIssueCode["EndNotAfterStart"] = "end_not_after_start";
    AttendanceCorrectionIssueCode["TimeOutsideShiftDay"] = "time_outside_shift_day";
    AttendanceCorrectionIssueCode["FutureDate"] = "future_date";
    AttendanceCorrectionIssueCode["BeforeEmploymentStart"] = "before_employment_start";
    AttendanceCorrectionIssueCode["MissingStartTime"] = "missing_start_time";
    // Warnings
    AttendanceCorrectionIssueCode["UnusualStart"] = "unusual_start";
    AttendanceCorrectionIssueCode["UnusualEnd"] = "unusual_end";
    AttendanceCorrectionIssueCode["OutOfPeriod"] = "out_of_period";
    AttendanceCorrectionIssueCode["PayrollAlreadyPaid"] = "payroll_already_paid";
})(AttendanceCorrectionIssueCode || (exports.AttendanceCorrectionIssueCode = AttendanceCorrectionIssueCode = {}));
/** Short Spanish labels, for chips and lists */
exports.ATTENDANCE_CORRECTION_ISSUE_LABELS = {
    [AttendanceCorrectionIssueCode.EndNotAfterStart]: 'Salida antes de la entrada',
    [AttendanceCorrectionIssueCode.TimeOutsideShiftDay]: 'Hora en otro día',
    [AttendanceCorrectionIssueCode.FutureDate]: 'Fecha futura',
    [AttendanceCorrectionIssueCode.BeforeEmploymentStart]: 'Antes del alta',
    [AttendanceCorrectionIssueCode.MissingStartTime]: 'Sin hora de entrada',
    [AttendanceCorrectionIssueCode.UnusualStart]: 'Entrada poco habitual',
    [AttendanceCorrectionIssueCode.UnusualEnd]: 'Salida poco habitual',
    [AttendanceCorrectionIssueCode.OutOfPeriod]: 'Fuera de periodo',
    [AttendanceCorrectionIssueCode.PayrollAlreadyPaid]: 'Nómina ya pagada',
};
/**
 * Entry before this Mexico wall-clock time is unusual (warning). Measured on 94 real
 * requests (Apr–Sep 2026): none started earlier.
 */
exports.ATTENDANCE_UNUSUAL_START_BEFORE = '07:30';
/**
 * Exit after this Mexico wall-clock time is unusual (warning). Exits between 20:30 and
 * 20:45 are routine (6 of 94 requests); none went past 21:00.
 */
exports.ATTENDANCE_UNUSUAL_END_AFTER = '21:00';
/**
 * Days after a fortnight closes during which a correction for it is still on time.
 * Covers reviewing on the 1st–3rd when those days are not working days.
 */
exports.ATTENDANCE_CORRECTION_GRACE_DAYS = 3;
